<div class="container">
  <div class="modal-content">
  <app-titulo>Pagamento Saída</app-titulo>
  <form [formGroup]="form">
    <app-input
      type="select"
      label="Forma de pagamento"
      placeholder="Selecione"
      name="NU_TIPO_PGMT_CAIX"
      formControlName="NU_TIPO_PGMT_CAIX"
      [selectData]="modoPagamentoOptions"
      (ngModelChange)="onChangeModoPagamento($event)"
      [requiredInput]="true">
    </app-input>
    <div class="valor-input">
      <app-input
        type="money"
        label="Valor pagamento"
        name="VL_PGMT_SAID_CAIX"
        formControlName="VL_PGMT_SAID_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true">
      </app-input>
      <add-button
        *ngIf="
          form.controls['NU_TIPO_PGMT_CAIX'].value &&
          form.controls['VL_PGMT_SAID_CAIX'].value
        "
        (click)="addPagamento()">
      </add-button>
    </div>
    <app-input
      type="money"
      label="Valor acréscimo"
      name="VL_ACRM_CAIX"
      formControlName="VL_ACRM_CAIX"
      placeholder="Digite aqui">
    </app-input>
    <app-input
      type="money"
      label="Valor desconto"
      name="VL_DSCT_CAIX"
      formControlName="VL_DSCT_CAIX"
      placeholder="Digite aqui">
    </app-input>
  </form>

  <div *ngIf="ServicoPagamentoTipoValor.length > 0" class="pagamentos-list">
    <h3>Pagamentos adicionados</h3>
    <ul>
      <li
        *ngFor="
          let pagamento of ServicoPagamentoTipoValor.controls;
          let i = index
        "
        class="pagamento">
        {{ pagamento.get('NM_TIPO_PGMT')?.value }} -
        {{
          pagamento.get('VL_PGMT_SAID_CAIX')?.value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
        <button type="button" class="action-button" (click)="removePagamento(i)">
          <img src="assets/delete-icon.svg" alt="Remover" />
        </button>
      </li>
    </ul>
  </div>
  </div>

  <div class="buttons">
    <div class="total-restante">
      <p>
        Total:
        {{
          form.controls['VL_TOTL'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </p>
      <p>
        Restante:
        {{
          form.controls['VL_REST'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </p>
    </div>
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()"></app-botao>
    <app-botao
      text="Confirmar"
      [bgColor]="disableConfirmar() ? '#d1d5db' : '#059669'"
      (click)="postPagamentoSaida()"
      [disabled]="disableConfirmar()">
    </app-botao>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
